import type { CsvTablePreviewDownload } from "./csvTablePreviewStore";

export function decodeBase64Bytes(contentBase64: string): Uint8Array<ArrayBuffer> {
  const binary = atob(contentBase64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes;
}

/** Save the preview's exact bytes under the given filename. */
export function downloadCsvTablePreviewFile(download: CsvTablePreviewDownload): void {
  const blob = new Blob([decodeBase64Bytes(download.contentBase64)], {
    type: download.mimeType ?? "text/csv;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = download.filename;
  link.click();
  URL.revokeObjectURL(url);
}
